// (A) 중립 체크박스 API — antd 미접촉. (B) PlainCheckbox(플레인) 에 위임.
import type { ChangeEvent, CSSProperties, ReactNode } from 'react'
import { PlainCheckbox } from '../_impl/PlainCheckbox'

export interface OmwCheckboxProps {
  checked?: boolean
  /** 부분 선택. */
  indeterminate?: boolean
  /** 편의: checked(boolean)만 전달. */
  onChange?: (checked: boolean) => void
  /**
   * ⚠ 원본 change 이벤트를 그대로 전달(escape-hatch). 기존 소비처가
   * e.nativeEvent(shift/ctrl-click 다중선택 판별)·e.stopPropagation() 을 쓰므로
   * event 를 숨기면 회귀.
   */
  onChangeEvent?: (e: ChangeEvent<HTMLInputElement>) => void
  disabled?: boolean
  /** 포커스 순서. */
  tabIndex?: number
  children?: ReactNode
  className?: string
  style?: CSSProperties
  'data-testid'?: string
}

export function OmwCheckbox(props: OmwCheckboxProps) {
  return <PlainCheckbox {...props} />
}
